import SettingTimesheetCreateRole from "../components/SettingTimesheetCreateRole";
import useStpTimeSheetCreateRole from "../hooks/useStpTimeSheetCreateRole";

const SettingTimesheetCreateRolePage = () => {
    const props = useStpTimeSheetCreateRole()
    return (
        <SettingTimesheetCreateRole {...props} />
    )
}

export default SettingTimesheetCreateRolePage;